import { useEffect } from 'react';
import { useLocation } from 'wouter';

/**
 * Hook personalizado para hacer scroll al inicio de la página
 * cada vez que cambia la ruta (navegación entre páginas)
 */
export const useScrollToTop = () => {
  const [location] = useLocation();

  useEffect(() => {
    // Hacer scroll al inicio de la página
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Scroll instantáneo sin animación
    });
  }, [location]); // Se ejecuta cada vez que cambia la ubicación
};

export default useScrollToTop; 